import { createSlice } from '@reduxjs/toolkit';

const initialAppStateSliceState =
{
    currentOffering: 1,
    currentMission: 1,
    currentStage: null,
    activeTab: "Overview",
    currentActivity: 1,
    nextStep: "Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat exercitation ullamco laboris, Pisi ut aliquip. Ut enim ad minim veniam, quis nostrud exercitation enim ad minim veniam, ullamco laboris.",
    missionTabs: [{ id: 1, name: "Overview", active: true, }, { id: 2, name: "Calender", active: false }],
    stageTabs: [{ id: 1, name: "Overview", active: true, isDisable: false }, { id: 2, name: "Solve", active: false, isDisable: false }, { id: 3, name: "Submit", active: false, isDisable: false }],
    connectionTabs: [{ id: 1, name: "My Connections", active: true, }, { id: 2, name: "Search", active: false }],
    mdConclaveTabs: [{ id: 1, name: "Conclave", active: true, }, { id: 2, name: "Nominate", active: false }],
    teamCoach: {},
    isTyping: false,
};

const appStateSlice = createSlice({
    name: 'appState',
    initialState: initialAppStateSliceState,
    reducers: {
        setCurrentMission(state, action) {
            state.currentMission = action.payload;
        },
        setCurrentStage(state, action) {
            state.currentStage = action.payload;
        },
        setActiveTab(state, action) {
            state.activeTab = action.payload;
        },
        setStageTabs(state, action) {
            state.stageTabs = action.payload;
        },
        setTeamCoach(state, action) {
            state.teamCoach = action.payload;
        },
        setIsTyping(state, action) {
            state.isTyping = action.payload;
        }

    },
});

export default appStateSlice;